/* src/app/shared/components/provider-classification-questions/provider-classification-questions.component.css */
.nz-padding-left {
  padding-left: 1rem;
}
.ppl-mt20 {
  margin-top: 20px;
}
.ant-radio-group {
  display: block;
}
.ant-radio-button-wrapper {
  width: 122px !important;
}
#servesAll .ant-radio-button-wrapper {
  width: 240px !important;
}
.derived-provider-type {
  border-top: 1px solid #e2f4f3;
  padding-top: 16px;
}
.derived-note {
  font-size: 12px;
  margin: 4px 0 0 0;
}
.classification-attestation {
  margin-top: 8px;
}
.classification-attestation label {
  font-weight: 600;
  white-space: normal;
  align-items: flex-start;
}
.classification-attestation .required-marker {
  color: #ff4d4f;
}
.attestation-error {
  display: block;
  margin-top: 4px;
}
/*# sourceMappingURL=provider-classification-questions.component-4KEU774X.css.map */
